enum QueryParamKeys {
  NumberOfMonths = 'numberOfMonths',
  Type = 'type',
  RegionId = 'regionId',
  AreaId = 'areaId',
  BranchId = 'branchId',
  MarketingId = 'marketingId',
  ProductId = 'productId',
  SPVMarketingId = 'spvMarketingId',
  BMMarketingId = 'bmMarketingId',
  AREMarketingId = 'areMarketingId',
  AgentMarketingId = 'agentMarketingId',
  ReportId = 'reportId',
  ActiveTab = 'activeTab',
  From = 'from',
  Month = 'month',
  StartDate = 'startDate',
  EndDate = 'endDate',
  OpenSetTarget = 'openSetTarget',
  Show = 'show',
  Category = 'category',
  WeekRangeOffset = 'weekRangeOffset',
  Page = 'page',
  City = 'city',
  Search = 'search',
}

export default QueryParamKeys;
